import React from 'react';
import { SubscriptionPlansContainer } from './SubscriptionPlansSection.style';
import HeadingWithIcon from './HeadingWithIcon';
import SubscriptionPlanCard from './SubscriptionPlanCard';


const SubscriptionPlansSection = () => {
    return (
        <SubscriptionPlansContainer>
            <div className='plans_section'>
                <div className='mygrid-container'>
                    <div className='mygrid-row plans-head_row'>
                        <div className='mygrid-col-md-12 mygrid-col-sm-12'>
                            <div className='plans-section-head'>
                                <h5 className='subheading'>Subscription</h5>
                                <HeadingWithIcon highlight="for Every Educator and Family">
                                    Flexible Plans
                                </HeadingWithIcon>
                                <p>
                                    Whether you're teaching a full class or supporting learning at home, Subjects Master has a plan that fits your needs. All subscriptions unlock full access to our game-based learning platform, including custom study guide, a shared global database, and real-time analytics.
                                </p>
                                <p>Choose a plan that grows with your learners and keeps them engaged every step of the way.</p>
                            </div>
                        </div>
                    </div>

                    <div className='mygrid-row plans_info_wrapper'>
                        <SubscriptionPlanCard
                            title="Basic Plan"
                            highlight="Affordable. Flexible. Designed to make learning fun."
                            description="Perfect for individual teachers, homeschoolers, or families looking to enhance learning with interactive games and custom study guide."
                            pricetext="Starting from"
                            price="$30 /mo"
                            bgColor="#FCC"
                            name="basic"
                        />

                        <SubscriptionPlanCard
                            title="Premium Plan"
                            highlight="Built for serious learning, with serious results."
                            description="Designed for educators, homeschool networks, and small schools who want to unlock the full power of Subjects Master with expanded features and flexibility."
                            pricetext="Starting from"
                            price="$100 /mo"
                            bgColor="#ACEBFF"
                            name="premium"
                        />

                        <SubscriptionPlanCard
                            title="Professional Plan"
                            highlight="Powerful tools. Scalable solutions. Built for schools and teams."
                            description="Designed for educators, administrators, and organizations that need collaborative tools, centralized management, and enterprise-level support to bring Subjects Master to entire classrooms, grade levels, or campuses."
                            pricetext="Starting from"
                            price="$458.25 /mo"
                            bgColor="#84F0CC"
                            name="professional"
                        />

                    </div>
                </div>
            </div>
        </SubscriptionPlansContainer>

    );
}

export default SubscriptionPlansSection;
